import React from "react";
import { SplideSlide } from "@splidejs/react-splide";
import { TbTargetArrow } from "react-icons/tb";
import { GrAchievement } from "react-icons/gr";
import { BiTask } from "react-icons/bi";
import Navbarss from "../navbars/Navbarss";

function MassTrain() {
  return (
    <div>
      <Navbarss />

      <div className="pt-24">
        {/* Hero Section */}
        <div className="relative w-full">
          <span className="absolute w-full h-full opacity-50 bg-black"></span>
          <img
            src="./image/bak.jpg"
            alt="telebirr"
            className="w-full h-auto object-cover"
          />
          <div className="absolute inset-0 flex flex-col justify-center items-center text-gray-500 px-4 text-center">
            <h1 className="font-extrabold text-white text-3xl md:text-4xl lg:text-5xl shadow-2xl">
              Mass Training
            </h1>
            <p className="p-4 text-white max-w-3xl">
              We developed this program to offer group training sessions that
              focus on basic life skills, work culture, and professional
              development. The goal is to lay a solid foundation for future
              trainings and initiatives.
            </p>
          </div>
        </div>

        <section class=" ">
          <div class="max-w-screen-xl px-4 py-4 mx-auto text-center lg:py-16 lg:px-6">
            <div class="text-center pb-12 rel">
              <h1 class="font-bold text-3xl md:text-4xl lg:text-5xl font-heading text-blue-400">
                Challenge
              </h1>
            </div>
            <figure class="max-w-screen-md mx-auto">
              <p class="text-md  text-gray-900 ">
                Currently, in Ethiopia’s crowded labor market, soft skills are
                in high demand by employers. They are also one of the strongest
                differentiating factors for the majority of Ethiopian youth
                struggling with prolonged unemployment. This is why Meklit
                Humanitarian Association created the mass training program - to
                provide our benefactors with a gift that differentiates them
                from the crowd and to provide some balance to the unbalanced
                labor market of the country.
              </p>
            </figure>
          </div>
        </section>
        <section class="  pt-8">
          <div class=" lg:col-span-7 flex justify-center items-center mt-6">
            <p class="max-w-2xl mb-4 text-2xl font-extrabold leading-none md:text-2xl xl:text-2xl ">
              <a href="/join" className="text-blue-400 font-normal text-center">
                Support Our Project
              </a>
            </p>
          </div>
          <div class="container mx-auto px-4 mb-6">
            <div class="flex flex-wrap">
              <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                <div class="max-w-md bg-white rounded-xl overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl hover:scale-105 transform transition-all duration-500 p-2">
                  <div class="px-4 py-5 flex-auto">
                    <div class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                      <BiTask className="w-8 h-8" />
                    </div>
                    <h6 class="text-xl font-semibold">What we do</h6>
                    <p class="mt-2 mb-4 text-blueGray-500">
                      In partnership with accredited training and consulting
                      companies, we create and carry out soft skill training in
                      the form of mass training for Orthodox youth.
                    </p>
                  </div>
                </div>
              </div>
              <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                <div class="max-w-md bg-white rounded-xl overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl hover:scale-105 transform transition-all duration-500 p-2">
                  <div class="px-4 py-5 flex-auto">
                    <div class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                      <GrAchievement className="w-8 h-8 " />
                    </div>
                    <h6 class="text-xl font-semibold">Achievement </h6>
                    <p class="mt-2 mb-10 text-blueGray-500">
                      In our first round of mass training, we collaborated with
                      Qine Counseling to offer group training sessions on
                      fundamental life skills, workplace culture, and
                      professional growth to 48 Orthodox youth.
                    </p>
                  </div>
                </div>
              </div>
              <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center ">
                <div class="max-w-md bg-white rounded-xl overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl hover:scale-105 transform transition-all duration-500 p-2">
                  <div class="px-4 py-5 flex-auto">
                    <div class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                      <TbTargetArrow className="w-8 h-8" />
                    </div>
                    <h6 class="text-xl font-semibold">2025/26 target</h6>
                    <p class="mt-2 mb-20 text-blueGray-500">
                      Meklit Humanitarian Association intends to provide this
                      training to about 2000 youths in Addis Abeba.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default MassTrain;
